import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

var _templateObject;

import Image from 'next/legacy/image';
import styled from 'styled-components';
import { Grid } from '@yoweb/ui/components/Grid';
import { Title } from '@yoweb/ui/components/typography';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { getSpace, getColor } from '@yoweb/ui/styles/utils/theme';
import { Container } from '@yoweb/ui/components/containers';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Invalid invitation page.
 * This page is displayed when user provides an invalid inviteCode in checkout process
 */
var InvalidInvitation = function InvalidInvitation() {
  var _useTranslation = useTranslation(['common', 'invalid-invitation']),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(InvalidInvitationContainer, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Grid, {
        columns: {
          _: '1fr',
          lg: '1fr 1fr'
        },
        gap: {
          _: 'medium1',
          lg: 'normal1'
        },
        align: "center",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Grid, {
            gap: "normal2",
            children: /*#__PURE__*/_jsxs(ContentWrapper, {
              children: [/*#__PURE__*/_jsx(Title, {
                size: {
                  _: 'lg',
                  md: 'xxl'
                },
                children: t('invalid-invitation:title')
              }), /*#__PURE__*/_jsx(TextWrapper, {
                children: /*#__PURE__*/_jsx(Title, {
                  as: "p",
                  weight: "regular",
                  size: {
                    _: 'xs',
                    md: 'sm'
                  },
                  children: /*#__PURE__*/_jsx(Trans, {
                    t: t,
                    i18nKey: "invalid-invitation:copy",
                    components: [/*#__PURE__*/_jsx(TextLink, {
                      href: "mailto:".concat(t('common:support-email')),
                      as: "a",
                      weight: "regular",
                      size: {
                        _: 'xs',
                        md: 'sm'
                      },
                      target: "_blank",
                      rel: "noreferrer",
                      children: t('common:support-email')
                    }, 0)],
                    values: {
                      email: t('common:support-email')
                    }
                  })
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(ImageWrapper // TODO(snaer): add the right artwork when ready
        , {
          src: "/images/invalid-invitation.png",
          alt: t('invalid-invitation:title'),
          width: "546",
          height: "615",
          objectFit: "cover"
        })]
      })
    })
  });
};

var InvalidInvitationContainer = styled.div.withConfig({
  componentId: "sc-16zbscr-0"
})(["padding-bottom:", ";padding-top:", ";", ""], getSpace('medium3'), getSpace('xl3'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n    padding-top: ", ";\n  "])), pxToRem(102), pxToRem(176)));
var ContentWrapper = styled.div.withConfig({
  componentId: "sc-16zbscr-1"
})(["max-width:", ";"], pxToRem(510));
var TextWrapper = styled.div.withConfig({
  componentId: "sc-16zbscr-2"
})(["margin-top:", ";"], getSpace('normal1'));
var ImageWrapper = styled(Image).withConfig({
  componentId: "sc-16zbscr-3"
})(["&&{mix-blend-mode:darken;}"]);
var TextLink = styled(Title).withConfig({
  componentId: "sc-16zbscr-4"
})(["&&{cursor:pointer;color:", ";text-decoration:underline;}"], getColor('base900'));
InvalidInvitation.layout = {
  type: 'marketing',
  props: {
    bgColor: 'base100'
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(InvalidInvitation);